import type { FormProps } from '../../types'
import styles from '../form.module.css'

export interface TextareaInput {
  name: string
  type: string
  customControlType: 'textarea'
  uiOptions?: {
    placeholder?: string
    testId?: string
    disabled?: boolean
  }
  validation?: {
    required?: boolean
    minLength?: number
    maxLength?: number
    pattern?: string
    min?: number
    max?: number
    step?: number
  }
}

export default function CustomTextarea({
  field,
  formProps,
}: {
  field: TextareaInput
  formProps: FormProps
}) {
  const minLength = field.validation?.minLength
  const maxLength = field.validation?.maxLength

  return (
    <div className="w-full">
      <textarea
        rows={4}
        className={styles.customTextarea}
        defaultValue={''}
        placeholder={field.uiOptions?.placeholder}
        {...formProps?.register(field.name, {
          required: field.validation?.required,
          minLength: minLength,
          maxLength: maxLength,
        })}
        data-testid={field.uiOptions?.testId}
        disabled={field.uiOptions?.disabled}
      />
      {(minLength || maxLength) && (
        <div className="mt-1 flex justify-between text-xs text-gray-500">
          {minLength && <span>Min: {minLength}</span>}
          {maxLength && <span>Max: {maxLength}</span>}
        </div>
      )}
    </div>
  )
}
